import Box from "@mui/material/Box";
import CustomContainer from "../CustomContainer";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { FaStethoscope } from "react-icons/fa";
import { BsFillTelephoneInboundFill } from "react-icons/bs";
import Typography from "@mui/material/Typography";
import { Tooltip } from "@mui/material";
import DashboardContext from "../../context/DashboardContext";
import { useContext } from "react";

export default function NumberOfMoreDataSaude(props) {
  const { customPrimaryColor } = useContext(DashboardContext);

  return (
    <CustomContainer
      sx={{
        alignItems: "center",
        display: "flex",
        height: "200px",
        justifyContent: "space-around",
      }}
    >
      {props.apontamento ? (
        <FaStethoscope color={customPrimaryColor} size={80} />
      ) : (
        <BsFillTelephoneInboundFill color={customPrimaryColor} size={80} />
      )}
      <Tooltip
        title={
          props.apontamento
            ? `WhatsApp : ${props.apontamentosWpp} Chamada : ${props.apontamentosTel}`
            : ""
        }
        arrow={true}
        placement={"left-start"}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            width: "220px",
            cursor: "default",
          }}
        >
          <Typography
            color="primary"
            component="p"
            sx={{ fontWeight: 600, cursor: "default" }}
            variant="h3"
          >
            {props.total || "-"}
          </Typography>
          <Typography sx={{ fontSize: "20px" }}>
            {props.apontamento
              ? "QUANTIDADE DE COSULTAS"
              : "QUANTIDADE DE CHAMADOS"}
          </Typography>
        </Box>
      </Tooltip>
    </CustomContainer>
  );
}
